/* global mo, L */

$(function(){
    // формы
    $(document).on('keydown change', 'input, select, textarea', function(){
        var $error_block = $(this);
        if(!$error_block.is('.error'))
            $error_block = $(this).parents('.error');

        $error_block.removeClass('error').next('.error-message').remove();
    });

    $(document).on('click', 'a.submit', function(event){
        event.preventDefault();
        $(this).closest('form').submit();
    });

    // Поля ввода с типом ЧИСЛО
    $(document).on('keyup', 'input.numeric', function(){
        var new_val = $(this).val().replace(/,/g, '.').replace(/\.+/g, '.').replace(/[^\d.]/, '');
        if($(this).val() != new_val) $(this).val(new_val);
    });

    // input
    $(document).on('focus', '.input input', function(){
        $(this).closest('.input').addClass('focus');
    });
    $(document).on('blur', '.input input', function(){
        $(this).closest('.input').removeClass('focus');
    });

    // checkbox
    $(document).on('click', 'label.checkbox:not(.disabled)', function(event){
//		if(!$(event.toElement).is('input')) return;

        if($(':checkbox', this).prop('checked')){
            $(this).addClass('checked');
            $(':checkbox', this).attr('checked', 'checked');
        }else{
            $(this).removeClass('checked');
            $(':checkbox', this).removeAttr('checked');
        }

        cb_unindeterminate($(this), true);
    });

    // radio
    $(document).on('click', 'label.radio:not(.disabled)', function(event){
//		if(!$(event.toElement).is('input')) return;

        var $radio = $(this);

        var name = $(':radio', this).attr('name');
        if(name) $radio = $('[name="' + name + '"]').closest('.radio');

        $.map($radio, function(radio){
            if($(':radio', radio).prop('checked')){
                $(radio).addClass('checked');
            }else{
                $(radio).removeClass('checked');
            }
        });
    });

    // select
    $(document).on('change.design', 'label.select select:not(.hidden)', function(){
        var text = $('option:selected', this).text();
        var icon = $('option:selected', this).data('icon') || false;

        if(icon) text = '<span class="icon-' + icon + '"></span>' + text;

        $(this).siblings('.text').html(text);

        var value = $(this).val();
        $('option:not(:selected)', this).removeAttr('selected');
        $('option:selected', this).attr('selected', 'selected');
    });

    $(document).on('click', 'label.select .changer', function(){
        var $select = $(this).siblings('select');

        var $option_next = $('option:selected', $select).next('option');
        if(!$option_next.length)
            $option_next = $('option:eq(0)', $select);

        $select.val($option_next.val()).change();
    });
    $('label.select:not(.exists_default) select').trigger('change.design');

    // элемент "Выбор на линейке"
    $('.ruler_selector a').click(function(event){
        event.preventDefault();

        var $ruler_selector = $(this).closest('.ruler_selector');

        $(this).parent().addClass('active').siblings().removeClass('active');
        $('input', $ruler_selector).val($(this).text());
    });

    inputs_init();
    setTimeout(inputs_selector_init, 100);
    inputs_autocomplete_init();
    inputs_file_init();
    editable_area_init();
    scroll_range_init();
});

function cb_on($cb, stop){
    $cb.closest('.checkbox').addClass('checked').children(':checkbox').prop('checked', true);
    if(!stop) cb_unindeterminate($cb, true);
}
function cb_off($cb, stop){
    $cb.closest('.checkbox').removeClass('checked').children(':checkbox').prop('checked', false);
    if(!stop) cb_unindeterminate($cb, true);
}
function cb_indeterminate($cb, stop){
    $cb.closest('.checkbox').addClass('indeterminate').children(':checkbox').prop('indeterminate', true);
    if(!stop) cb_off($cb, true);
}
function cb_unindeterminate($cb, stop){
    $cb.closest('.checkbox').removeClass('indeterminate').children(':checkbox').prop('indeterminate', false);
    if(!stop) cb_off($cb, true);
}
function cb_enable($cb){
    $cb.closest('.checkbox').removeClass('disabled').children(':checkbox').removeAttr('disabled');
}
function cb_disable($cb){
    $cb.closest('.checkbox').addClass('disabled').children(':checkbox').attr('disabled', 'disabled');
}
function radio_on($radio){
    $radio.closest('.radio').addClass('checked').children(':radio').prop('checked', true);
}

function radio_off($radio){
    $radio.closest('.radio').removeClass('checked').children(':radio').prop('checked', false);
}

function inputs_init(){
    // Поля ввода с очисткой
    $.map($('input.cleaner'), function(el){
        if($(el).data('cleaner_complite'))
            return;
        $(el).data('cleaner_complite', true);

        $(el).wrap('<div class="cleaner"></div>');

        var $cleaner = $('<a class="icon-remove cleaner"></a>');
        $cleaner.click(function(){
            $(this).hide();
            $(el).val('').keyup().change().focus();
        });
        $(el).after($cleaner);

        $(el).keyup(function(){
            if($(this).val())
                $cleaner.fadeIn();
        });
        $(el).keyup(function(event){
            if(!$(this).val())
                $cleaner.hide();
            else if(event.which == 27)
                $cleaner.click();
            else if(event.which)
                $cleaner.show();
        });
        $(el).keydown(function(event){
            if(event.which == 27)
                $cleaner.click();
        });

        $(el).focus(function(){
            $(this).parent().addClass('focus');
        });
        $(el).blur(function(){
            $(this).parent().removeClass('focus');
        });
    });

    // Поля ввода с поиском (важен порядок функций, после "Поля ввода input.cleaner")
    $.map($('input.searcher'), function(el){
        if($(el).data('searcher_complite'))
            return;
        $(el).data('searcher_complite', true);

        if($(el).parent().is('.cleaner'))
            $(el).parent().addClass('searcher');
        else
            $(el).wrap('<div class="searcher"></div>');

        var $icons = $('<span class="icon-search"></span><span class="load icon-spin"></span>');
        $(el).after($icons);

        $(el).focus(function(){
            $(this).parent().addClass('focus');
        });
        $(el).blur(function(){
            $(this).parent().removeClass('focus');
        });
    });

    // Поля с автовызовом события change при вводе текста
    var timer;
    var temp;
    $('input.autochange').keyup(function(event){
        if(temp == $(this).val()) return; // значение не изменилось
        temp = $(this).val();

        if(!event.originalEvent) return;
        if(event.keyCode == 27 && $(this).is('.cleaner')) return; // событие будет запущено другим обработчиком (см. "Поля ввода input.cleaner")

        $that = $(this);

        clearTimeout(timer);
        timer = setTimeout(function(){
            $that.change();
        }, 300);
    });
}

// <input type="text" data-selector="true" data-module="mod_common" data-func="regions" data-get_item="inputs_selector_get_item">
function inputs_selector_init(){
    $.map($('input[data-selector]'), function(el){
        var $input = $(el);

        $input.addClass('autocomplete');

        var $input_selector = $('<div class="input_selector">');
        var name = $input.attr('name');
        var $values_input = $('<input type="hidden" name="' + name + '" >');

        var $results = $('<div class="input_selector-results autocomplete-results">');

        $input
        .removeAttr('name')
        .wrap($input_selector)
        .after($values_input)
        .after($results);

        $input_selector = $input.closest('.input_selector');
        $input_selector.width($input.width());
        var h = $input.height() - $input_selector.css('padding-top').replace('px', '') * 1 - $input_selector.css('padding-bottom').replace('px', '') * 1;
        $input_selector.css({'min-height': h + 'px'});

        $input_selector.click(function(){
            $input.focus();
        });

        $input
        .focus(function(){
            $input_selector.addClass('focus');
        })
        .blur(function(){
            $input_selector.removeClass('focus');
        })
        .keydown(function(){
            var min_w = $input_selector.width() - 50;
            $.map($('.input_selector-value', $input_selector), function(el){
                min_w -= ($(el).width() + 30);
            });
            if(min_w < 50) min_w = 50;

            var w = $(this).val().length * 9;
            if(w < min_w) w = min_w;
            if(w < $values_input.width()) $input.width(w);
        })
        .keydown();

        // удаление
        $input_selector.on('click', '.input_selector-value .del', function(event){
            event.preventDefault();

            $(this).parent().remove();
            set_values();
            $input.keydown();
        });

        // добавление (поиск)
        var module = $input.data('module');
        var func = $input.data('func');
        var get_item = eval($input.data('get_item')) || inputs_selector_get_item;
        var timer;
        var last_value = '';
        $input.keyup(function(){
            var search = $input.val();
            if(search == last_value) return;
            last_value = search;
            clearTimeout(timer);

            if(!search) return $results.empty().hide();

            timer = setTimeout(function(){
                mo.get(function(res){
                    $results.empty().hide();

                    if(res.length){
                        $.map(res, function(el){
                            var values = $values_input.val();
                            var expr = new RegExp('(^|,)' + el.id + '(,|$)', 'i');
                            if(values.match(expr)) return; // значение уже добавлено

                            $results.append(get_item(el, search));
                        });

                        if($('a', $results).length){
                            $('a:eq(0)', $results).addClass('active');
                            $results.show();
                        }
                    }
                }, module, func, {search: search});
            }, 300);
        });
        $input.blur(function(){
            clearTimeout(timer);
            $results.empty().hide();
            $(this).val('');
        });

        $results.on('click', 'a', function(event){
            event.preventDefault();
        });
        $results.on('mousedown', 'a', function(){
            var value = $(this).data('value');
            var label = $(this).text();
            add_value(value, label);

            $results.empty().hide();
            setTimeout(function(){
                $input.val('').focus();
            });
        });

        var add_value = function(value, label){
            var values = $values_input.val();
            var expr = new RegExp('(^|,)' + value + '(,|$)', 'i');
            if(values.match(expr)) return; // значение уже добавлено

            var $value = $('<div class="input_selector-value">' + label + '<a href="." class="icon-remove del"></a></div>').data('value', value);
            $input.before($value);

            set_values();
            $input.keydown();
        };

        // просчет нового значения
        var set_values = function(){
            var values = [];
            $.map($('.input_selector-value', $input_selector), function(value){
                values.push($(value).data('value'));
            });

            values = values.join(',');
            $values_input.val(values);
        };
    });
}

function inputs_selector_get_item(el, search){
    return '<a href="." data-value="' + el.id + '">' + (el.label ? el.label : el.name) + '</a>';
}

// функции autocomplete
function inputs_autocomplete_init(){
    $(document).on('mousemove', '.autocomplete-results a', function(){
        $('a', $(this).closest('.autocomplete-results')).removeClass('active');
        $(this).addClass('active');
    });

    $(document).on('keydown', 'input.autocomplete', function(event){
        if(event.keyCode != 38 && event.keyCode != 40) return;

        var $results = $(this).siblings('.autocomplete-results');

        var $active = $('.active', $results);
        var index = $active.index();
        if(!$active.length){
            $active = $('a', $results).eq(0).addClass('active');
            index = -1;
        }

        if(event.keyCode == 38) index--; // вверх
        if(event.keyCode == 40) index++; // вниз

        if(index > $('a', $results).length - 1) index = 0;
        if(index < 0) index = $('> a', $results).length - 1;

        $('a', $results).removeClass('active');
        $('a', $results).eq(index).addClass('active');
        $(this).addClass('active');
    }).on('keyup', 'input.autocomplete', function(event){
        if(event.keyCode != 13) return;

        var $results = $(this).siblings('.autocomplete-results');
        $('.active', $results).mousedown();
    }).on('blur', 'input.autocomplete', function(){
        var $results = $(this).siblings('.autocomplete-results');
        $results.empty().hide();
    });
}

// поле выбора файлов (поддерживается только выбор одиночного файла)
// <input type="file" class="open_file" placeholder="Перетащите файл сюда или нажмите Обзор" data-browse_text="Обзор" data-exts="csv,txt" data-max_size="5242880" />
function inputs_file_init($context){
    if(!$context)
        $context = $(document);

    var $inputs_file = $(':file.open_file', $context);
    $inputs_file
    .wrap('<div class="open_file_wrapper">')
    .after('<div class="drag_over_block" data-text_here="' + L.FILE_Drop_here + '" data-text_done="' + L.FILE_Drop_here_done + '">' + L.FILE_Drop_here + '</div>')
    .after('<a href="." class="icon-remove del" title="' + L.Delete + '"></a>')
    .after('<div class="filename"></div>')
    .after('<a href="." class="browse"><span class="icon-folder-open folder"></span><span class="text">' + L.FILE_Browse + '</span></a>');

    $.map($inputs_file, function(input_files){
        var $input_file_wrapper = $(input_files).parent();
        var $input_file = $(input_files);
        var $filename = $input_file.siblings('.filename');
        var $browse = $input_file.siblings('.browse');
        var browse_text = $input_file.data('browse_text') || L.FILE_Browse;
        var exts = $input_file.data('exts') || false;
        var max_size = $input_file.data('max_size') || false;

        $('.text', $browse).html(browse_text);

        title = $input_file.attr('placeholder') || L.FILE_Select;
        $filename.text(title);

        // отмена выбора файла
        $('a.icon-remove', $input_file_wrapper).click(function(event){
            event.preventDefault();
            $input_file.val('').change();
        });

        // выбор файла
        $('a.browse', $input_file_wrapper).click(function(event){
            event.preventDefault();
            $input_file.click();
        });

        // событие: файл выбран
        $input_file.change(function(){
            if(window.File){
                var files = $input_file[0].files;

                // файл не выбран
                if(!files.length){
                    $filename.text(title);
                    $input_file_wrapper.removeClass('selected');
                    return;
                }

                // файл выбран
                files_names = [];
                $.map(files, function(file){
                    if(!file) return; // файл вероятно был удален из списка
                    //
                    // проверить соответствия типу файла
                    if(exts){
                        var file_ext = file.name.match(/\.([^.]+)$/);
                        if(file_ext) file_ext = file_ext[1].toLowerCase();
                        if((',' + exts + ',').indexOf(',' + file_ext + ',') == -1){
                            $input_file.val('').change();
                            mo.information_add('"' + file.name + '": ' + L.FILE_Select_extension + ' ' + exts.replace(/,/g, '/'), 1);
                            return;
                        }
                    }

                    // проверить размер файла
                    if(max_size){
                        if(file.size > max_size){
                            var max_MB = Math.round(max_size / 1024 / 1024 * 100) / 100;
                            if(max_MB > 1){
                                mo.information_add('"' + file.name + '": ' + L.FILE_Exceeds_max_size + ' (' + max_MB + ' MB)', 1);
                            }else{
                                var max_KB = Math.round(max_size / 1024 * 100) / 100;
                                mo.information_add('"' + file.name + '": ' + L.FILE_Exceeds_max_size + ' (' + max_KB + ' KB)', 1);
                            }

                            $input_file.val('').change();

                            return;
                        }
                    }

                    files_names.push(file.name);
                });

                if(files_names.length){
                    $input_file_wrapper.addClass('selected');
                    $filename.text(files_names.join(', '));
                }else{
                    $input_file_wrapper.removeClass('selected');
                    $filename.text(title);
                }
            }
        });

        // перетаскивание файла в поле ввода
        $('.drag_over_block', $input_file_wrapper)[0].ondragover = function(event){
            if(event.dataTransfer.types[0] == 'Files') $(this).addClass('drag_over').html($(this).data('text_done'));
        };
        $('.drag_over_block', $input_file_wrapper)[0].ondragleave = function(){
            $(this).removeClass('drag_over').html($(this).data('text_here'));
        };
        $('.drag_over_block', $input_file_wrapper)[0].ondrop = function(event){
            event.preventDefault();
            $('body').removeClass('drag_over');

            if(!event.dataTransfer.files.length) return;
            $input_file[0].files = event.dataTransfer.files;
            $input_file.change();
        };
    });

    // перетаскивание файла в окно
    var timer;
    document.ondragover = function(event){
        if(event.dataTransfer.types[0] == 'Files'){
            clearTimeout(timer);
            $('body').addClass('drag_over');

            var $open_file_wrapper = $('.open_file_wrapper:visible');
            if($open_file_wrapper.length == 1){
                var $drag_over_block = $open_file_wrapper.eq(0).children('.drag_over_block');
                $drag_over_block.addClass('drag_over').html($drag_over_block.data('text_done'));
            }

            if($open_file_wrapper.length) return false;
        }
    };
    document.ondragleave = function(){
        timer = setTimeout(function(){
            $('body').removeClass('drag_over');
        }, 10);
    };
    document.ondrop = function(event){
        if(event.dataTransfer && event.dataTransfer.types[0] != 'Files') return;

        event.preventDefault();
        if($(event.target).is('.drag_over_block')) return; // файл перетаскивается в выбранное подготовленное поле

        if($('.drag_over_block:visible').length)
            $('.drag_over_block:visible')[0].ondrop(event); // сбросить файл в первое подготовленное поле
    };
}

function editable_area_init(){
    //<div class="editable_area" data-id="id" data-minlen="minlen" data-maxlen="maxlen" data-name="name" data-value="value" data-module="module" data-fedit="fedit"></div>
    $.map($('.editable_area'), function(el){
        if($(el).is('.editable_area-on')) return;
        $(el).addClass('editable_area-on');

        var id = $(el).data('id');
        var minlen = ($(el).data('minlen') != undefined) ? $(el).data('minlen') * 1 : 1;
        var maxlen = $(el).data('maxlen');
        var name = $(el).data('name');
        var value = $(el).data('value');
        var module = $(el).data('module');
        var fedit = $(el).data('fedit');
        if(!fedit) fedit = '';
        var col_type = $(el).data('col_type');
        var epmty_text = 'Не заполнено';

        var $value = $('<div class="value">' + (value ? value : epmty_text) + '</div>');
        var $input = $('<input name="' + name + '" type="text">');
        var $edit = $('<a href="." class="icon-pencil edit" title="Редактировать"></a>');

        var max_width = $(el).parent().width() - 30;
        $value.css('max-width', max_width);

        $(el).append($value, $input, $edit);

        $edit.click(function(event){
            event.preventDefault();

            if($(el).is('.editable_area-edit')){
                $(el).removeClass('editable_area-edit');
                if($input.val() == 'null' || $input.val().length < minlen)
                    return $value.text(value ? value : epmty_text); // вернуть прежнее значение

                value = $input.val();
                $value.text(value ? value : epmty_text);

                var data = {};
                data[name] = value;
                data['id'] = id;
                if(col_type)
                    data['col_type'] = col_type;
                mo.edit(function(){

                }, module, fedit, data);
            }else{
                $(el).addClass('editable_area-edit');
                $input.val(value).focus();
                $input.width($value.width());
            }
        });

        $value.dblclick(function(){
            $edit.click();
        });

        $input.keydown(function(event){
            var $that = $(this);
            setTimeout(function(){
                if($that.val().length > maxlen)
                    $that.val($that.val().substr(0, maxlen));
                $value.text($that.val());

                $that.width($value.width() + 3);

                if(event.keyCode == 13)
                    $edit.click();
                if(event.keyCode == 27){
                    $that.val('null');
                    $edit.click();

                }
            });
        });
    });
}

/*
 <input type="text" name="input" value="0" />
 <input type="text" name="input_2" value="100" />
 <div class="scroll-range" data-input_name="input" data-input_name_2="input_2" data-min="0" data-max="100"></div>
 */
function scroll_range_init(){
    $.map($('.scroll-range'), function(el){
        var $input = $(el).siblings('[name="' + $(el).data('input_name') + '"]');

        var range = ($(el).data('input_name_2') != undefined) ? true : 'min';
        var value = $input.val();
        var values = [];

        if(range == true){
            var $input_2 = $(el).siblings('[name="' + $(el).data('input_name_2') + '"]');
            var values = [$input.val(), $input_2.val()];
        }

        var min = ($(el).data('min') != undefined) ? $(el).data('min') : 0;
        var max = ($(el).data('max') != undefined) ? $(el).data('max') : 100;

        $(el).slider({
            range: range,
            min: min,
            max: max,
            value: value,
            values: values,
            slide: function(event, ui){
                if(range == true){
                    $input.val(ui.values[0]);
                    $input_2.val(ui.values[1]);
                }else{
                    $input.val(ui.value);
                }
            }
        });

        $(el).data('slider_reset', function(){
            if(range == true){
                $input.val(min);
                $input_2.val(max);

                $(el).slider('values', [min, max]);
            }else{
                $input.val(min);

                $(el).slider('value', min);
            }
        });
    });
}